import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { CommissionTierItemDto } from '../../commission-tier-items/dtos/commission-tier-item.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';

/**
 * Agent category DTO for records
 */
@CaslSubject(AppSubjectEnum.AGENT_CATEGORY)
export class AgentCategoryRecordDto extends BaseDto {
  name!: string;
  description?: string | null;
  notes?: string | null;
  commissionTierItems?: CommissionTierItemDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
}
